function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** ~3 minutes max (60 × 2s) — évite un loader infini. */
export const PAYMENT_POLL_INTERVAL_MS = 2000;
/** Durée maximale d’attente de confirmation Mobile Money (~60 s). */
export const PAYMENT_POLL_DURATION_MS = 60_000;
export const PAYMENT_POLL_MAX_ATTEMPTS = Math.ceil(PAYMENT_POLL_DURATION_MS / PAYMENT_POLL_INTERVAL_MS);

/** Confirmation payout admin FlexPay (~45 s). */
export const WITHDRAWAL_PAYOUT_POLL_INTERVAL_MS = 2000;
export const WITHDRAWAL_PAYOUT_POLL_DURATION_MS = 45_000;
export const WITHDRAWAL_PAYOUT_POLL_MAX_ATTEMPTS = Math.ceil(
  WITHDRAWAL_PAYOUT_POLL_DURATION_MS / WITHDRAWAL_PAYOUT_POLL_INTERVAL_MS,
);

/**
 * @param {{
 *   fetchStatus: () => Promise<string>;
 *   onStatus?: (status: string) => void;
 *   onAttempt?: (attempt: number, maxAttempts: number) => void;
 *   signal?: AbortSignal;
 *   successStatuses: string[];
 *   failureStatuses: string[];
 *   maxAttempts?: number;
 *   intervalMs?: number;
 * }} params
 * @returns {Promise<string>} Statut final (VALIDEE, ECHOUEE, TIMEOUT, …)
 */
export async function pollPaymentStatus(params) {
  const maxAttempts = params.maxAttempts ?? PAYMENT_POLL_MAX_ATTEMPTS;
  const intervalMs = params.intervalMs ?? PAYMENT_POLL_INTERVAL_MS;
  const successSet = new Set(params.successStatuses.map((s) => s.trim().toUpperCase()));
  const failureSet = new Set(params.failureStatuses.map((s) => s.trim().toUpperCase()));

  for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
    if (params.signal?.aborted) {
      return 'CANCELLED';
    }

    params.onAttempt?.(attempt, maxAttempts);

    try {
      const rawStatus = await params.fetchStatus();
      const nextStatus = String(rawStatus ?? '')
        .trim()
        .toUpperCase();
      if (nextStatus) {
        params.onStatus?.(nextStatus);
      }
      if (successSet.has(nextStatus)) {
        return nextStatus;
      }
      if (failureSet.has(nextStatus)) {
        return nextStatus;
      }
    } catch {
      // erreur réseau ponctuelle — on continue jusqu'au timeout
    }

    if (attempt < maxAttempts) {
      await sleep(intervalMs);
      if (params.signal?.aborted) {
        return 'CANCELLED';
      }
    }
  }

  return 'TIMEOUT';
}
